




import { Component, Prop, Vue } from 'vue-property-decorator';
import { getAvatarIconUrl } from '@/utils/utils';

@Component
export default class UserIcon extends Vue {
  @Prop({ required: true })
  name!: string;

  get icon() {
    return getAvatarIconUrl(this.name);
  }
}
